import { gql, useLazyQuery } from "@apollo/client";
// import { LoginErrorVar, LoginSuccessVar } from 'lib/reactiveVars'
import React, { useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const LOGIN_QUERY = gql`
  query LOGIN_QUERY($email: String!, $password: String!) {
    loginQuery(email: $email, password: $password)
  }
`;
interface AuthContextType {
  login: (email: string, password: string) => void;
  logout: () => void;
  isAuthenticated: boolean;
  role: string | null;
  error: string | null;
}
interface AuthContextType {
  login: (email: string, password: string) => void;
  logout: () => void;
  isAuthenticated: boolean;
  role: string | null;
}

const isValidToken = () => {
  const token = localStorage.getItem("furnisystems-token");

  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    if (Date.now() >= (decoded.exp ?? 0) * 1000) {
      return false;
    }

    return true;
  } catch (e) {
    return false;
  }
};

const AuthContext = React.createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState(isValidToken());
  const [role, setRole] = React.useState(null);
  const [loginError, setLoginError] = React.useState<string | null>(null);
  const [loginQuery, { data, error }] = useLazyQuery(LOGIN_QUERY);

  const login = (email: string, password: string) => {
    loginQuery({ variables: { email, password } });
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.setItem("furnisystems-token", ``);
    setRole(null);
  };

  useEffect(() => {
    if (data) {
      const token = data.loginQuery;
      localStorage.setItem("furnisystems-token", `${token}`);
      setIsAuthenticated(true);
      setRole(data.loginQuery.role);
      setLoginError(null);
    }
    if (error) {
      setIsAuthenticated(false);
      setRole(null);
      setLoginError("Invalid email or password");
    }
  }, [data, error]);

  return (
    <AuthContext.Provider
      value={{ login, logout, isAuthenticated, role, error: loginError }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
